import React from "react";
import { stats } from "../mock";

const Stats = () => {
  return (
    <section className="bg-neutral-950 text-white py-14">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s) => (
            <div key={s.label} className="text-center md:text-left">
              <p className="font-heading font-extrabold text-4xl md:text-5xl text-brand">{s.value}</p>
              <p className="mt-2 text-sm text-neutral-400">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
